var map = {
	"./alert/balance.png": 1693,
	"./alert/bg-balance.png": 7067,
	"./alert/learning.png": 6979,
	"./alert/social.png": 3412,
	"./apexchart/radial-image.png": 8202,
	"./avatars/1.jpg": 6332,
	"./avtar/11.jpg": 6067,
	"./avtar/16.jpg": 4416,
	"./avtar/3.jpg": 4614,
	"./avtar/4.jpg": 957,
	"./avtar/7.jpg": 3154,
	"./banner/1.jpg": 226,
	"./banner/2.jpg": 6157,
	"./banner/3.jpg": 3936,
	"./big-lightgallry/01.jpg": 6380,
	"./big-lightgallry/010.jpg": 2878,
	"./big-lightgallry/011.jpg": 9339,
	"./big-lightgallry/012.jpg": 1644,
	"./big-lightgallry/013.jpg": 5369,
	"./big-lightgallry/014.jpg": 6426,
	"./big-lightgallry/015.jpg": 5431,
	"./big-lightgallry/016.jpg": 6504,
	"./big-lightgallry/02.jpg": 1035,
	"./big-lightgallry/03.jpg": 2990,
	"./big-lightgallry/04.jpg": 8613,
	"./big-lightgallry/05.jpg": 7944,
	"./big-lightgallry/06.jpg": 4279,
	"./big-lightgallry/07.jpg": 6538,
	"./big-lightgallry/08.jpg": 7649,
	"./big-lightgallry/09.jpg": 5844,
	"./big-masonry/1.jpg": 1302,
	"./big-masonry/10.jpg": 4764,
	"./big-masonry/11.jpg": 1641,
	"./big-masonry/12.jpg": 1374,
	"./big-masonry/13.jpg": 9419,
	"./big-masonry/14.jpg": 6328,
	"./big-masonry/15.jpg": 6997,
	"./big-masonry/2.jpg": 9073,
	"./big-masonry/3.jpg": 548,
	"./big-masonry/4.jpg": 2511,
	"./big-masonry/5.jpg": 6162,
	"./big-masonry/6.jpg": 4653,
	"./big-masonry/7.jpg": 1200,
	"./big-masonry/8.jpg": 6107,
	"./big-masonry/9.jpg": 9646,
	"./blog/12.png": 5140,
	"./blog/14.png": 8930,
	"./blog/4.jpg": 6553,
	"./blog/9.jpg": 6608,
	"./blog/blog-2.jpg": 8052,
	"./blog/blog-3.jpg": 8001,
	"./blog/blog-5.jpg": 783,
	"./blog/blog-6.jpg": 464,
	"./blog/blog-single.jpg": 6240,
	"./blog/blog.jpg": 6617,
	"./blog/comment.jpg": 6526,
	"./blog/img.png": 4044,
	"./customizer/dark.png": 1446,
	"./customizer/light.png": 5480,
	"./customizer/mix.png": 7606,
	"./dashboard-1/hand.png": 9802,
	"./dashboard-1/icon/1.png": 8006,
	"./dashboard-1/icon/2.png": 8685,
	"./dashboard-1/icon/3.png": 6180,
	"./dashboard-1/icon/4.png": 6123,
	"./dashboard-1/icon/5.png": 7122,
	"./dashboard-1/icon/6.png": 2265,
	"./dashboard-1/icon/cancel.png": 2433,
	"./dashboard-1/icon/checked.png": 5716,
	"./dashboard-1/icon/danger.png": 8710,
	"./dashboard-1/img-1.png": 6170,
	"./dashboard-1/img-2.png": 4481,
	"./dashboard-1/img-3.png": 4536,
	"./dashboard-1/img-4.png": 6055,
	"./dashboard-1/img-5.png": 8366,
	"./dashboard-1/news-update/1.png": 7436,
	"./dashboard-1/news-update/2.png": 7495,
	"./dashboard-1/news-update/3.png": 9182,
	"./dashboard-1/news-update/4.png": 193,
	"./dashboard-1/news-update/5.png": 2328,
	"./dashboard-1/news-update/6.png": 7603,
	"./dashboard-1/news-update/7.png": 26,
	"./dashboard-1/user/01.png": 188,
	"./dashboard-1/user/02.png": 6599,
	"./dashboard-1/user/03.png": 8286,
	"./dashboard-1/user/04.png": 9297,
	"./dashboard-1/user/05.png": 5080,
	"./dashboard-1/user/06.png": 355,
	"./dashboard-1/user/07.png": 9130,
	"./dashboard-1/user/1.png": 7240,
	"./dashboard-1/user/2.png": 2995,
	"./dashboard-1/user/3.png": 4138,
	"./dashboard-1/welcome-bg.png": 1281,
	"./dashboard-2/1.png": 1555,
	"./dashboard-2/2.png": 712,
	"./dashboard-2/3.png": 3425,
	"./dashboard-2/4.png": 6686,
	"./dashboard-2/5.png": 327,
	"./dashboard-2/6.png": 1596,
	"./dashboard-2/animate/1.png": 4171,
	"./dashboard-2/animate/2 (1).png": 7058,
	"./dashboard-2/animate/2.png": 5840,
	"./dashboard-2/animate/3.png": 313,
	"./dashboard-2/animate/4.png": 230,
	"./dashboard-2/animate/5.png": 7167,
	"./dashboard-2/flag/1.png": 2278,
	"./dashboard-2/flag/2.png": 3517,
	"./dashboard-2/flag/3.png": 2388,
	"./dashboard-2/flag/4.png": 8299,
	"./dashboard-2/flag/5.png": 7170,
	"./dashboard-2/timeline/5.png": 4985,
	"./dashboard-2/timeline/6.png": 6802,
	"./dashboard-2/user/01.png": 1843,
	"./dashboard-2/user/02.png": 6232,
	"./dashboard-2/user/03.png": 7361,
	"./dashboard-2/user/04.png": 2526,
	"./dashboard-2/user/05.png": 2023,
	"./dashboard-2/user/06.png": 4444,
	"./dashboard-2/user/07.png": 357,
	"./dashboard-2/user/08.png": 5330,
	"./dashboard-2/user/09.png": 9483,
	"./dashboard-2/user/10.png": 2853,
	"./dashboard-2/user/11.png": 6940,
	"./dashboard-2/user/12.png": 9591,
	"./dashboard-2/user/13.png": 7102,
	"./dashboard-2/user/14.png": 2574,
	"./dashboard-2/user/15.png": 9976,
	"./dashboard-2/user/16.png": 3187,
	"./dashboard-2/user/17.png": 9082,
	"./dashboard-2/user/18.png": 6861,
	"./dashboard-3/user/1.png": 3854,
	"./dashboard-3/user/10.png": 3548,
	"./dashboard-3/user/11.png": 6437,
	"./dashboard-3/user/12.png": 6078,
	"./dashboard-3/user/13.png": 1655,
	"./dashboard-3/user/14.png": 2664,
	"./dashboard-3/user/15.png": 3793,
	"./dashboard-3/user/16.png": 9562,
	"./dashboard-3/user/17.png": 8419,
	"./dashboard-3/user/18.png": 3124,
	"./dashboard-3/user/19.png": 8538,
	"./dashboard-3/user/2.png": 4853,
	"./dashboard-3/user/20.png": 8145,
	"./dashboard-3/user/21.png": 9752,
	"./dashboard-3/user/22.png": 1731,
	"./dashboard-3/user/3.png": 5756,
	"./dashboard-3/user/4.png": 5923,
	"./dashboard-3/user/5.png": 4698,
	"./dashboard-3/user/6.png": 4865,
	"./dashboard-3/user/7.png": 648,
	"./dashboard-3/user/8.png": 2911,
	"./dashboard-3/user/9.png": 6582,
	"./details_close.png": 3441,
	"./details_open.png": 2005,
	"./ecommerce/01.jpg": 7782,
	"./ecommerce/02.jpg": 7393,
	"./ecommerce/03.jpg": 9348,
	"./ecommerce/04.jpg": 5727,
	"./ecommerce/05.jpg": 9346,
	"./ecommerce/06.jpg": 8301,
	"./ecommerce/07.jpg": 9088,
	"./ecommerce/08.jpg": 1867,
	"./ecommerce/banner.jpg": 689,
	"./ecommerce/card.png": 6633,
	"./ecommerce/mastercard.png": 9007,
	"./ecommerce/paypal.png": 6894,
	"./ecommerce/product-table-1.png": 919,
	"./ecommerce/product-table-2.png": 6988,
	"./ecommerce/product-table-3.png": 2901,
	"./ecommerce/product-table-4.png": 2474,
	"./ecommerce/product-table-5.png": 4387,
	"./ecommerce/product-table-6.png": 8776,
	"./ecommerce/visa.png": 884,
	"./email-template/1.jpg": 2235,
	"./email-template/1.png": 7171,
	"./email-template/10.jpg": 9955,
	"./email-template/11.jpg": 6790,
	"./email-template/12.jpg": 6369,
	"./email-template/2.png": 1416,
	"./email-template/3.png": 2545,
	"./email-template/4.png": 4830,
	"./email-template/5.png": 4055,
	"./email-template/6.png": 5948,
	"./email-template/7.jpg": 9813,
	"./email-template/7.png": 8837,
	"./email-template/8.jpg": 2998,
	"./email-template/8.png": 4306,
	"./email-template/banner-2.jpg": 5723,
	"./email-template/banner.jpg": 7838,
	"./email-template/cosmetic.jpg": 2949,
	"./email-template/delivery-2.png": 1997,
	"./email-template/delivery.png": 3000,
	"./email-template/facebook.png": 4,
	"./email-template/gplus.png": 6457,
	"./email-template/invoice-1/1.png": 1457,
	"./email-template/invoice-1/sign.png": 5249,
	"./email-template/invoice-3/bg-0.png": 4498,
	"./email-template/invoice-3/bg.png": 881,
	"./email-template/invoice-3/sign.png": 1007,
	"./email-template/linkedin.png": 8634,
	"./email-template/order-success.png": 1852,
	"./email-template/pdfs.png": 7921,
	"./email-template/pinterest.png": 8708,
	"./email-template/slider.jpg": 2123,
	"./email-template/space.jpg": 6844,
	"./email-template/success.png": 6343,
	"./email-template/twitter.png": 3579,
	"./email-template/youtube.png": 7197,
	"./email/3.jpg": 6600,
	"./faq/1.jpg": 8398,
	"./faq/2.jpg": 7993,
	"./faq/3.jpg": 2732,
	"./faq/4.jpg": 2695,
	"./faq/learning-1.png": 3111,
	"./favicon.jpg": 7582,
	"./favicon.png": 170,
	"./file-manager/folder.png": 5689,
	"./file-manager/folder1.png": 1460,
	"./forms/Bank-of-Baroda.png": 6326,
	"./forms/MasterCard.png": 8852,
	"./forms/SCB.png": 9986,
	"./forms/authenticate.png": 9159,
	"./forms/axis.png": 5287,
	"./forms/credit-card.png": 4396,
	"./forms/delivery.png": 3660,
	"./forms/email.png": 9582,
	"./forms/flags.png": 6287,
	"./forms/hdfc.png": 9493,
	"./forms/idbi.png": 3588,
	"./forms/qr-bg.jpg": 2321,
	"./forms/qr-code.png": 7199,
	"./forms/qr-scan.png": 3859,
	"./forms/qr-scan1.png": 6466,
	"./forms/rbl.png": 66,
	"./forms/us-bank.png": 3245,
	"./forms/user.png": 2157,
	"./gif/danger.gif": 2467,
	"./gif/facebook.gif": 9202,
	"./gif/instagram.gif": 3462,
	"./gif/logout.gif": 2496,
	"./gif/online-shopping.gif": 8196,
	"./gif/qr-scan.gif": 6631,
	"./gif/success/successful.gif": 6224,
	"./gif/whatapp.gif": 381,
	"./job-search/1.jpg": 2718,
	"./job-search/2.jpg": 7865,
	"./job-search/3.jpg": 76,
	"./job-search/4.jpg": 311,
	"./job-search/5.jpg": 8378,
	"./job-search/6.jpg": 5605,
	"./knowledgebase/bg_1.jpg": 8655,
	"./lightgallry/01.jpg": 6399,
	"./lightgallry/010.jpg": 5695,
	"./lightgallry/011.jpg": 3986,
	"./lightgallry/012.jpg": 9917,
	"./lightgallry/013.jpg": 7696,
	"./lightgallry/014.jpg": 3971,
	"./lightgallry/015.jpg": 838,
	"./lightgallry/016.jpg": 8593,
	"./lightgallry/02.jpg": 2784,
	"./lightgallry/03.jpg": 746,
	"./lightgallry/04.jpg": 550,
	"./lightgallry/05.jpg": 3715,
	"./lightgallry/06.jpg": 8436,
	"./lightgallry/07.jpg": 6481,
	"./lightgallry/08.jpg": 5338,
	"./lightgallry/09.jpg": 9799,
	"./lightgallry/default-skin.png": 6569,
	"./lightgallry/default-skin.svg": 4527,
	"./login/1.jpg": 8750,
	"./login/2.jpg": 4166,
	"./login/3.jpg": 4275,
	"./login/icon.png": 4378,
	"./login/login_bg.jpg": 7665,
	"./logo.png": 2145,
	"./logo/favicon.jpg": 9184,
	"./logo/favicon1.png": 6471,
	"./logo/logo-dark.png": 9186,
	"./logo/logo-main.png": 8861,
	"./logo/logo-mini.png": 7687,
	"./logo/logo-mini.svg": 1413,
	"./logo/logo-white.png": 6719,
	"./logo/logo.png": 6447,
	"./logo/logo.svg": 3071,
	"./logo/logo1.png": 9622,
	"./logo/range.svg": 8045,
	"./logo/range2.svg": 533,
	"./logo/range3.svg": 5812,
	"./logo/range4.svg": 7963,
	"./logo/range5.svg": 8906,
	"./masonry/1.jpg": 1419,
	"./masonry/10.jpg": 4739,
	"./masonry/11.jpg": 3126,
	"./masonry/12.jpg": 2737,
	"./masonry/13.jpg": 4692,
	"./masonry/14.jpg": 7423,
	"./masonry/15.jpg": 1042,
	"./masonry/2.jpg": 6252,
	"./masonry/3.jpg": 601,
	"./masonry/4.jpg": 8506,
	"./masonry/5.jpg": 663,
	"./masonry/6.jpg": 7816,
	"./masonry/7.jpg": 8997,
	"./masonry/8.jpg": 2790,
	"./masonry/9.jpg": 1315,
	"./other-images/bg-profile.png": 3887,
	"./other-images/boxbg.jpg": 138,
	"./other-images/coming-soon-bg.jpg": 1823,
	"./other-images/dark-logo-login.png": 4796,
	"./other-images/emoji/angry.png": 1884,
	"./other-images/emoji/love.png": 8747,
	"./other-images/emoji/sad.png": 655,
	"./other-images/emoji/smile.png": 2847,
	"./other-images/emoji/think.png": 6027,
	"./other-images/headphones.png": 7819,
	"./other-images/img-1.jpg": 4735,
	"./other-images/img-2.jpg": 2035,
	"./other-images/img-3.jpg": 2509,
	"./other-images/img-4.jpg": 6166,
	"./other-images/img-cropper.jpg": 8697,
	"./other-images/invoice.svg": 8411,
	"./other-images/logo-login.png": 99,
	"./other-images/maintenance-bg.jpg": 8465,
	"./other-images/mountain.jpg": 9279,
	"./other-images/paypal.png": 3687,
	"./other-images/profile-bg.png": 511,
	"./other-images/profile-style-img.png": 461,
	"./other-images/profile-style-img3.png": 4466,
	"./other-images/profile.png": 4247,
	"./other-images/sea.jpg": 2389,
	"./other-images/sidebar-bg.jpg": 2270,
	"./product-1/1.png": 2677,
	"./product-1/2.png": 2318,
	"./product-1/3.png": 7895,
	"./product-1/4.png": 8904,
	"./product/1.png": 2983,
	"./product/10.png": 4167,
	"./product/11.png": 6478,
	"./product/12.png": 2229,
	"./product/13.png": 5692,
	"./product/14.png": 9507,
	"./product/15.png": 4282,
	"./product/2.png": 2924,
	"./product/3.png": 2021,
	"./product/4.png": 5514,
	"./product/category/1.png": 3624,
	"./product/category/2.png": 8115,
	"./product/category/3.png": 2906,
	"./product/category/4.png": 7573,
	"./product/category/5.png": 4508,
	"./product/product-categories/1.png": 5762,
	"./product/product-categories/2.png": 6473,
	"./product/product-categories/drone.png": 517,
	"./product/product-categories/dvd.png": 6377,
	"./product/product-categories/headphone.png": 1037,
	"./product/product-categories/ipad.png": 151,
	"./product/product-categories/keyboard.png": 1476,
	"./product/product-categories/laptop.png": 7327,
	"./product/product-categories/mac-laptop.png": 2885,
	"./product/product-categories/mouse.png": 4570,
	"./product/product-categories/phone.png": 5567,
	"./product/product-categories/speaker.png": 7552,
	"./product/product-categories/watch-2.png": 2480,
	"./product/product-categories/watch.png": 4154,
	"./product/product-categories/wireless-headphone.png": 6454,
	"./profile.png": 7173,
	"./scrollbar/fashion1.jpg": 7160,
	"./scrollbar/fashion2.jpg": 1911,
	"./scrollbar/fashion3.jpg": 8074,
	"./scrollbar/fashion4.jpg": 8761,
	"./scrollbar/fashion5.jpg": 716,
	"./scrollbar/fashion6.jpg": 3515,
	"./search-not-found.png": 5379,
	"./slider/1.jpg": 1719,
	"./slider/10.jpg": 5639,
	"./slider/11.jpg": 7421,
	"./slider/2.jpg": 2792,
	"./slider/3.jpg": 53,
	"./slider/4.jpg": 9166,
	"./slider/5.jpg": 5627,
	"./slider/6.jpg": 7932,
	"./slider/7.jpg": 5305,
	"./slider/8.jpg": 5682,
	"./slider/9.jpg": 5679,
	"./social-app/post-1.png": 924,
	"./social-app/post-2.png": 9031,
	"./social-app/post-3.png": 3454,
	"./social-app/post-4.png": 1169,
	"./social-app/post-5.png": 40,
	"./social-app/post-6.png": 5795,
	"./social-app/post-7.png": 586,
	"./social-app/post-8.png": 3533,
	"./social-app/post-9.png": 500,
	"./social-app/social-image.png": 8709,
	"./social-app/timeline-1.png": 1763,
	"./social-app/timeline-2.png": 9800,
	"./social-app/timeline-3.png": 929,
	"./social-app/timeline-4.png": 2446,
	"./start-conversion.jpg": 3418,
	"./switch/1.jpg": 2360,
	"./switch/2.jpg": 9639,
	"./switch/3.jpg": 2122,
	"./switch/4.jpg": 8585,
	"./switch/5.jpg": 3324,
	"./switch/6.jpg": 3947,
	"./switch/7.jpg": 8990,
	"./switch/8.jpg": 6733,
	"./switch/square-gray.png": 6710,
	"./switch/square.svg": 6044,
	"./user/1.jpg": 5585,
	"./user/1.png": 777,
	"./user/10.jpg": 7341,
	"./user/11.jpg": 8768,
	"./user/11.png": 3044,
	"./user/12.jpg": 3119,
	"./user/12.png": 8159,
	"./user/14.jpg": 9665,
	"./user/14.png": 5385,
	"./user/16.png": 2955,
	"./user/2.jpg": 3382,
	"./user/2.png": 8661,
	"./user/3.jpg": 3491,
	"./user/3.png": 2171,
	"./user/4.jpg": 4688,
	"./user/4.png": 2260,
	"./user/5.jpg": 9581,
	"./user/5.png": 8941,
	"./user/6.jpg": 354,
	"./user/7.jpg": 2063,
	"./user/8.jpg": 4316,
	"./user/9.jpg": 4841,
	"./user/img.png": 6253,
	"./user/user-dp.png": 8810,
	"./user/user.png": 7907,
	"./users/1.png": 3042,
	"./users/2.png": 3753,
	"./users/3.png": 8928,
	"./users/4.png": 255,
	"./users/5.png": 3926,
	"./users/6.png": 5549,
	"./widget-bg.png": 4350,
	"./widget/widget-bg.png": 8949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4002;